export const getOriginalHolidayDate = (id: number | null, data: { id: number; date: string }[]) => {
  const elem = data.find((holiday) => holiday.id === id);
  if (elem) {
    const dateString = elem.date;
    const nextYear = new Date(dateString).getFullYear() + 1;
    return `${nextYear}${dateString.substring(4)}`;
  }
  return undefined;
};
